import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'ui/atoms/buttons';
import { ContainerWrapper } from 'components/reusable/containers';

const NotFoundWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80vh;
    text-align: center;

    h1 {
        font-size: 48px;
        margin-bottom: 16px;
        color: #333;
    }

    p {
        font-size: 18px;
        margin-bottom: 24px;
        color: #666;
    }
`;

function NotFoundPage() {
    return (
        <ContainerWrapper>
            <NotFoundWrapper>
                <h1>404</h1>
                <p>Oops! The page you are looking for does not exist.</p>
                <Link to="/">
                    <Button>Go Back Home</Button>
                </Link>
            </NotFoundWrapper>
        </ContainerWrapper>
    );
}

export default NotFoundPage;